import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    undo: string;
    success: (name: string, isDeactivated: boolean) => string | React.ReactNode;
    successUndo: (isUndoDeactivate: boolean) => string | React.ReactNode;
    failure: string;
    retry: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to undo status change */
            undo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useProjectStatusToggle.undo?c=n4og3f213zda", defaultMessage: "Undo" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success toast message after toggling project status */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string, isDeactivated: boolean) => __intl__.intl().formatMessage({ id: "useProjectStatusToggle.success?c=1gvu8bqaokwat", defaultMessage: "\"{name}\" project is marked {isDeactivated, select, true {Inactive} other {Active}}" }, { name: name, isDeactivated: isDeactivated }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success toast message after undoing the status change */
            successUndo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (isUndoDeactivate: boolean) => __intl__.intl().formatMessage({ id: "useProjectStatusToggle.successUndo?c=3gvx1xpfwukzq", defaultMessage: "Marking {isUndoDeactivate, select, true {inactive} other {active}} undone" }, { isUndoDeactivate: isUndoDeactivate }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error toast title when status update fails */
            failure: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useProjectStatusToggle.failure?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to retry a failed status update */
            retry: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useProjectStatusToggle.retry?c=24r9hk1amvd4v", defaultMessage: "Retry" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
